<template>
  <div class="data-layOut">
    <LeftMenu :active-router="routeInfo.name"/>
    <div class="layOut-right">
      <div class="layout-title">
        <i class="iconfont icon-shouye"></i>
        <span>数据中心 / </span>
        <span class="route-name">{{ routeInfo.title }}</span>
      </div>
      <div class="router-page">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import LeftMenu from "./components/LeftMenu";
export default {
  name: "LayOut",
  components: { LeftMenu },
  data () {
    return {
      routeInfo: {
        name: '',
        title: ''
      }
    }
  },
  mounted() {
    this.getRouteInfo()
  },
  watch: {
    $route() {
      this.getRouteInfo()
    }
  },
  methods: {
    getRouteInfo () {
      this.routeInfo.name = this.$route.name
      this.routeInfo.title = this.$route.meta.title
    }
  }
}
</script>

<style scoped lang="less">
.data-layOut{
  height: calc(100vh - 125px);
  margin: 10px 20px;
  background-image: url("../../assets/dp/bottom-left.png");
  background-size: 100% 100%;
  display: flex;
  .layOut-right{
    width: calc(100% - 311px);
    height: 100%;
    padding-right: 25px;
    .layout-title{
      height: 75px;
      border-bottom: 1px solid #00B2FF;
      font-size: 26px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 85px;
      i{
        font-size: 23px;
        margin-right: 5px;
      }
      .route-name{
        text-shadow: 3px 3px 5px #00B2FF;
      }
    }
    .router-page{
      height: calc(100% - 75px);
      width: 100%;
    }
  }
}
</style>
